export default __webpack_public_path__ + "static/media/lever.9d06ad08.svg";